import { render, staticRenderFns } from "./LeagueList.vue?vue&type=template&id=3972b483&"
import script from "./LeagueList.vue?vue&type=script&lang=js&"
export * from "./LeagueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports